import { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import config from "@/config";

const clientVersion = config.get("version");

export default class VersionInterceptor {
  static setVersionInterceptor(axios: AxiosInstance) {
    axios.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        /* eslint-disable-next-line no-param-reassign */
        config.headers.ClientVersion = clientVersion;
        return config;
      },
      (error: AxiosError) => Promise.reject(error)
    );
  }
}
